// src/App.jsx
import "./styles/vars.css"
import useIsDesktop from "./hooks/useIsDesktop";
import { useEffect, useState } from "react";
import DesktopApp from "./components/desktop/DesktopApp";
import MobileApp from "./components/mobile/MobileApp";
import MobileSiteApp from "./components/mobile/site/MobileSiteApp";

/* 👇 добави това */
import { LangProvider } from "./i18n/LangContext";

export default function App() {
  const isDesktop = useIsDesktop(1024);
  const [currentPath, setCurrentPath] = useState(() => (typeof window !== "undefined" ? window.location.pathname : "/"));
  const isExternalOfferwallPath = currentPath === "/offerwallExternal";
  const isOfferwallPath = currentPath === "/offerwall" || isExternalOfferwallPath;

  useEffect(() => {
    if (typeof window === "undefined") return;
    const onPopState = () => setCurrentPath(window.location.pathname || "/");
    window.addEventListener("popstate", onPopState);
    return () => window.removeEventListener("popstate", onPopState);
  }, []);

  const isMobileOfferwall =
    isExternalOfferwallPath ||
    (!isDesktop && (isOfferwallPath || currentPath === "/contact" || currentPath === "/presentation"));

  return (
    <LangProvider>
      <div className="page-bg">
        {isMobileOfferwall ? <MobileApp allowDesktop={isExternalOfferwallPath} /> : isDesktop ? <DesktopApp /> : <MobileSiteApp />}
      </div>
    </LangProvider>
  );
}
